module.exports = __webpack_public_path__ + "static/media/pid_checklist_gold.edb38fd3.svg";